import React, { Component } from 'react';
import PassengersListWrapper from '../../passengersList/PassengersListWrapper';
import RouteTabs from '../../routeTabs/RouteTabs';
import SeatSelectionDialog from './SeatSelectionDialog';
import SeatsMobileProps from './SeatsMobileProps';
import Dictionary from '../../../model/Dictionary';
import './SeatsMobile.css';
import SeatRowAction from '../../passengersList/SeatRowAction';
import Constants from '../../../model/AppConfiguration';

export default class SeatsMobileScreen extends Component {
  static propTypes = SeatsMobileProps;

  submitData = step => {
    this.props.submitFlights(Constants.REQUEST.SEATS, this.props.general, this.props.flights, step);
  };

  render () {
    const {
      routeId,
      routes,
      selectedRoute,
      selectedTrip,
      toggleRoutes,
      editOpened,
      selectedPassenger,
      openEditPassenger,
      closeEditPassenger,
    } = this.props;

    return (
      <div className='seats-mobile' id='mobile-container'>
        <h1>{Dictionary.seats.title}</h1>
        <RouteTabs
          centered
          showDate
          routes={routes}
          selectedTrip={selectedTrip}
          selectedRoute={selectedRoute}
          toggleRoutes={toggleRoutes}
          TabContent={
            <PassengersListWrapper
              showOnlySelected
              routeId={routeId}
              onItemClickAction={openEditPassenger}
              selectedPassenger={selectedPassenger}
              RowAction={SeatRowAction}
            />
          }
        />
        <SeatSelectionDialog
          centered
          showDate
          routes={routes}
          selectedTrip={selectedTrip}
          selectedRoute={selectedRoute}
          toggleRoutes={toggleRoutes}
          editOpened={editOpened}
          handleClose={closeEditPassenger}
          selectedPassenger={selectedPassenger}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/seats/mobile/SeatsMobileScreen.js